import { render } from "./ForumPost.vue?vue&type=template&id=d1843b20"
import script from "./ForumPost.vue?vue&type=script&lang=js"
export * from "./ForumPost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__